/* eslint-disable no-underscore-dangle */
import type { AppThunk } from '../store/configureStore';
import { showAPIError } from './api-error';

// eslint-disable-next-line import/prefer-default-export
export const login =
  (organization: string, email: string, password: string): AppThunk =>
  async (dispatch) => {
    const response = await fetch(`/login`, {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify({
        organization,
        email,
        password,
        _csrf_token: (window as any)._csrf_token,
      }),
    });
    if (!response.ok) {
      dispatch(showAPIError(await response.json().catch(() => ({}))));
      return;
    }
    window.location.href = '/'; // redirect top.
  };
